/*
  Поява блоків при скролі для секцій головної.

  Один спостерігач на сторінку, а не по одному в кожній секції: секцій багато,
  і кожна зі своїм IntersectionObserver — це зайві підписки на скрол.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    root.querySelectorAll('.bz-rv, .bz-rv-img').forEach(function (el) {
      el.classList.add('is-in');
    });
    if (root.classList && (root.classList.contains('bz-rv') || root.classList.contains('bz-rv-img'))) {
      root.classList.add('is-in');
    }
  }

  if (!('IntersectionObserver' in window) || reduce) {
    revealAll(document);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        // Стрічка розкривається цілком: її праві картки поза в'юпортом по X
        // і поодинці ніколи б не спрацювали.
        if (e.target.classList.contains('bz-rail')) revealAll(e.target);
        else e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  );

  function observe(root) {
    root.querySelectorAll('.bz-rail').forEach(function (r) { io.observe(r); });
    root.querySelectorAll('.bz-rv, .bz-rv-img').forEach(function (el) {
      if (!el.closest('.bz-rail')) io.observe(el);
    });
  }

  observe(document);

  // У кастомайзері секція перемальовується без перезавантаження сторінки
  document.addEventListener('shopify:section:load', function (e) {
    revealAll(e.target);
  });
})();
